import { render, staticRenderFns } from "./pre_base_table_20210522.vue?vue&type=template&id=78df57f5&scoped=true"
import script from "./pre_base_table_20210522.vue?vue&type=script&lang=js"
export * from "./pre_base_table_20210522.vue?vue&type=script&lang=js"
import style0 from "./pre_base_table_20210522.vue?vue&type=style&index=0&id=78df57f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df57f5",
  null
  
)

export default component.exports